/**
 * ProtectedERPRoute Component
 * 
 * Componente que protege rotas do ERP baseado em permissões.
 * Verifica se o usuário tem a permissão ERP.view antes de permitir acesso.
 */

import { Navigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { usePermissions } from '../hooks/usePermissions'
import { MODULES, ACTIONS } from '../hooks/usePermissions'

function ProtectedERPRoute({ children }) {
  const { isAuthenticated, isAdmin, loading: authLoading } = useAuth()
  const { hasPermission, loading: permissionsLoading } = usePermissions()

  // Aguardar carregamento de autenticação e permissões
  if (authLoading || permissionsLoading) {
    return <div style={{ padding: '2rem', textAlign: 'center' }}>Carregando...</div>
  }

  // Se não estiver autenticado, redirecionar para login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  // Admin sempre tem acesso
  if (isAdmin()) {
    return children
  }

  // Verificar se tem permissão ERP.view
  if (!hasPermission(MODULES.ERP, ACTIONS.VIEW)) {
    return <Navigate to="/" replace />
  }

  return children
}

export default ProtectedERPRoute

